import { combineEpics } from 'redux-observable';

import authorizationRedirects from './authorizationRedirects';
import termsOfService from './termsOfService';
import { removeLocalStorageJWT } from './removeLocalStorageJWT';

require('./multitabRedirects');

export default combineEpics(
  removeLocalStorageJWT,
  authorizationRedirects,
  termsOfService,
);
